export const FYP_PAGE_ID = "FYP";
export const FYP_PAGE_URL = "https://websim.com/fyp";

const FYP_HTML = /* html */ `deprecated`;

export const fypPage = {
  url: FYP_PAGE_URL,
  content: FYP_HTML as string,
  title: "For You - websim.com",
};
